module.exports = __webpack_public_path__ + "img/7-0-1.ef02e837.png";